import axios from "axios";

export const qwFleet = axios.create({
  baseURL: process.env.QW_FLEET_URL,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: { indexes: null },
});

qwFleet.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && process.env.HOME_PAGE_URL) {
      window.location.href = process.env.HOME_PAGE_URL;
    }
    return Promise.reject(error);
  },
);
